var swiperPerView = $('.cartRecommendationSwiper').attr('data-swiper-slides');
var swiper = new Swiper(".cartRecommendationSwiper", {
  slidesPerView: 1,
  spaceBetween: 20,
  loop: true,
  centeredSlides: true,
  pagination: {
    el: ".js-cart-recommendation-swiper-pagination",
    type: "progressbar",
  },
  navigation: {
    nextEl: ".js-cart-recommendation-swiper-button-next",
    prevEl: ".js-cart-recommendation-swiper-button-prev"
  },
  breakpoints: {
    374: {
      slidesPerView: 2,
    },
    640: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: swiperPerView,
      centeredSlides: false,
    },
  },
});